import { createContext, useEffect, useRef } from "react";
import { io } from "socket.io-client";
import { useAuth } from "../hooks/useAuth";
import { useLocation } from "react-router-dom";

export const SocketContext = createContext({});

const publicRoutes = ["/", "/login", "/register", "/forgot-password", '/e-check', /^\/resgatar-echeck\/[^/]+$/];

export function SocketProvider({ children }) {
  const socketRef = useRef(null);
  const { user } = useAuth();
  const location = useLocation();

  const apiUrl = process.env.REACT_APP_URL_API_V1?.replace('/api/v1/web', '');

  const isPublicRoute = publicRoutes.some(route =>
    typeof route === "string"
      ? route === location.pathname
      : route instanceof RegExp && route.test(location.pathname)
  );

  useEffect(() => {
    const shouldConnect = user && !isPublicRoute;

    if (!user?.id || isPublicRoute) return;

    if (shouldConnect && !socketRef.current) {
      console.log("✅ Conectando socket...");
      const socket = io(apiUrl, {
        query: {
          userId: user.id,
        },
        transports: ["websocket"],
      });

      socket.on("connect", () => {
        console.log("🔌 WebSocket conectado");
        socket.emit("register", user.id);
      });

      socket.on("disconnect", () => {
        console.log("🔌 WebSocket desconectado");
      });

      socketRef.current = socket;
    }

    if (!user?.id && socketRef.current) {
      console.log("❌ Desconectando socket...");
      socketRef.current.disconnect();
      socketRef.current = null;
    }

    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
        console.log("🔌 WebSocket desconectado ao desmontar");
      }
    };
  }, [user?.id]);

  return (
    <SocketContext.Provider
      value={socketRef.current}
    >
      {children}
    </SocketContext.Provider>
  );
}
